export default __webpack_public_path__ + "static/media/calculator.4e6cb1b8.svg";